/*
 * This file is for all mfc-specific utilities.
 * Place generic utilities in the `utilities` folder.
 */

export function playDingSound(sound = 2, incoming = true) {
    // to avoid making multiple requests to this audio file
    // we will store it on the DOM on the first request
    // and play it back from there
    // if the element is missing, we will re-instantiate it
    // eslint-disable-next-line fp/no-let
    let audioElement: HTMLAudioElement = document.querySelector('#pm-ding')
    const isIncoming = incoming ? 'down' : 'up'
    const soundSource = `/static/sounds/ding${sound}_${isIncoming}.wav`
    if (!audioElement) {
        audioElement = new Audio(soundSource)
        audioElement.id = 'pm-ding'
        audioElement.volume = 0.2
        document.querySelector('body').appendChild(audioElement)
    } else if (audioElement.src?.includes(soundSource) === false) {
        // if the user has changed their PM Notification Sound Setting
        // remove old element (src will not update in DOM if changed manually)
        audioElement.remove()
        audioElement = new Audio(soundSource)
        audioElement.id = 'pm-ding'
        audioElement.volume = 0.2
        document.querySelector('body').appendChild(audioElement)
    }
    audioElement.play().catch(() => {
        console.log('cannot play sound without a user interaction')
    })
}
